<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong>  Modulo Refinancimiento de Crédito - Listar</strong>
          </CCardHeader>
          <CCardBody>
            <b-row>
         

                <b-col sm="12" md="8">
          
                </b-col>

                
                <b-col sm="6" md="3">
                  <b-form-group label=".">
                    <b-input-group>
                    <b-form-input v-model="search" class="form-control"></b-form-input>
                    <b-input-group-append>
                      <b-button variant="primary" @click="ListCreditRefinance"><b-icon icon="search"></b-icon></b-button>
                    </b-input-group-append>
                  </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col sm="6" md="1">
                  <b-form-group label=".">
                    <b-link  v-if="Permission('CreditRefinanceAdd')" class="btn form-control btn-primary"  :to="{ path: '/refinanciar-credito/nuevo' }" append ><i class="fas fa-file"></i></b-link>
                  </b-form-group>
                </b-col>
            </b-row>

            <div class="table-responsive mt-3 table_refinance">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th width="3%" class="text-center">#</th>
                    <th width="7%" class="text-center">F. Solicitud</th>
                    <th width="7%" class="text-center">Código</th>
                    <th width="35%" class="text-center">Cliente</th>
                    <th width="7%" class="text-center">Crédito <br> Anterior</th>
                    <th width="7%" class="text-center">Crédito <br> Nuevo </th>
                    <th width="8%" class="text-center">Monto</th>
                    <th width="5%" class="text-center">Cuotas</th>
                    <th width="10%" class="text-center">Usuario</th>
                    <th width="8%" class="text-center">Estado</th>
                    <th width="7%" class="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody v-for="(item, it) in data_table" :key="it">
                  <tr :class=" item.credit_plus == 1 ? 'bg-info':''">
                    <td class="text-center">{{ it + 1 }}</td>
                    <td class="text-center"> {{ item.registration_date  }}</td>
                    <td class="text-center"> {{ item.code  }}</td>
                    <td class="text-left"> {{ item.client_name  }}</td>
                    <td class="text-center"> {{ item.credit_code  }}</td>
                    <td class="text-center"> {{ item.new_credit_code  }}</td>
                    <td class="text-right"> {{ item.amount  }}</td>
                    <td class="text-right"> {{ item.dues  }}</td>
                    <td class="text-left"> {{ item.user  }}</td>
                    <td class="text-center">
                        <b-badge v-if="item.state == 1" variant="success">Realizado</b-badge>
                        <b-badge v-if="item.state == 0" variant="danger">Anulado</b-badge>  
                        
                    </td>
                    <td class="text-center">
                      <b-dropdown bloque size="sm" text="Acciones" right>
                        <b-dropdown-item v-if="Permission('CreditRefinanceEdit')" @click="EditCredit(item.id_credit_refinance)" >Editar</b-dropdown-item>
                        <b-dropdown-item v-if="Permission('CreditRefinanceView')" @click="ViewCredit(item.id_credit_refinance)" >Ver</b-dropdown-item>
                        <b-dropdown-item  v-if="Permission('CreditRefinanceDelete')" @click="ConfirmDeleteCredit(item.id_credit_refinance)">Anular</b-dropdown-item>

                        <b-dropdown-item @click="OpenCreditRefinancing(item.id_credit_refinance)" >PDF Refinanciamiento de crédito </b-dropdown-item>
                        <b-dropdown-item @click="OpenCreditRefinancingAgreement(item.id_credit_refinance)" >PDF Contrato de Refinanciamiento</b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <b-row class="mt-4">
              <b-col md="8">
                <b-pagination v-model="currentPage" v-on:input="ListCreditRefinance" :total-rows="rows" :per-page="perPage" align="center" ></b-pagination>
              </b-col>
              <b-col md="4 text-center">
                <p>Pagina Actual: {{ currentPage }}</p>
              </b-col>
            </b-row>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<style>
 .table_refinance{
  min-height: 500px;
 }
</style>

<script>
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import "vue-select/src/scss/vue-select.scss";

const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";
import CodeToName from "@/assets/js/CodeToName";
var moment = require("moment");
export default {
  name: "CreditRefinanceList",
  components:{
    vSelect,
  },
  data() {
    return {
      module:'CreditRefinance',
      perPage: 15,
      currentPage: 1,
      rows: 0,
      data_table: [],
      search: "",
    };
  },
  mounted() {
    this.ListCreditRefinance();
  },
  methods: {
    ListCreditRefinance,
    EditCredit,
    ViewCredit,
    ConfirmDeleteCredit,
    DeleteCredit,
    Permission,

    OpenCreditRefinancingAgreement,
    OpenCreditRefinancing,
  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
    user: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user;
    }
  },
};

function ListCreditRefinance() {

  let search = this.search == "" ? "all" : this.search;
  let me = this;
  let url = this.url_base + "credit-refinance/list/"+this.user.id_branch_office+"/"+ search + "?page=" + this.currentPage;

  axios({
    method: "GET",
    url: url,
    headers: { token: this.token, module: this.module, role: 1,},
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.rows = response.data.result.total;
        me.data_table = response.data.result.data;
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

// Editar usuario
function EditCredit(id_credit_refinance) {
  this.$router.push({
    name: "CreditRefinanceEdit",
    params: { id_credit_refinance: je.encrypt(id_credit_refinance) },
  });
}

// Ver Usuario
function ViewCredit(id_credit_refinance) {
  this.$router.push({
    name: "CreditRefinanceView",
    params: { id_credit_refinance: je.encrypt(id_credit_refinance) },
  });
}

// Confirmar eliminar
function ConfirmDeleteCredit(id_credit_refinance) {
  Swal.fire({
    title: "Esta seguro de eliminar la refinanciación del crédito?",
    text: "No podrás revertir esto!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, Estoy de acuerdo!",
  }).then((result) => {
    if (result.value) {
      this.DeleteCredit(id_credit_refinance);
    }
  });
}

// eliminar usuario
function DeleteCredit(id_credit_refinance) {
  let me = this;
  let url = this.url_base + "credit-refinance/cancel/" + id_credit_refinance;
  axios({
    method: "delete",
    url: url,
    headers: {token: this.token, module: this.module,role: 4,},
  })
    .then(function (response) {
       if (response.data.status == 200) {
        const index = me.data_table.map(item => item.id_credit_refinance).indexOf(response.data.result.id_credit_refinance);
        me.data_table.splice(index, 1);
        Swal.fire({ icon: 'success', text: response.data.message, timer: 3000,})
      } else {
        Swal.fire({ icon: 'error', text: response.data.message, timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

function OpenCreditRefinancingAgreement(id_credit) {
  let me = this;
  let url = me.url_base + "credit-refinancing-agreement-pdf/"+id_credit+"/"+this.user.id_user;
  window.open(url,'_blank');
}

function OpenCreditRefinancing(id_credit) {
  let me = this;
  let url = me.url_base + "credit-refinancing-pdf/"+id_credit+"/"+this.user.id_user;
  window.open(url,'_blank');
}


// permisos
function Permission(module_permission) {
  let user_permissions = window.localStorage.getItem("user_permissions");
  user_permissions = JSON.parse(JSON.parse(je.decrypt(user_permissions)));
  if (user_permissions.indexOf(module_permission) > -1) {
    return true;
  } else {
    return false;
  }
}
</script>